import variableBindingMixin from './variableBindingMixin.jsx';
import { arrayExpressionRestoreValue } from './variableBinding.js';

/**
 * Essentials stand-in when an array-typed field holds a non-array value.
 * Advanced's JSON eye stores a Flow expression as a string. The list, tab,
 * checkbox, tag, and multi-select controls must not walk or mutate that string.
 *
 * FlowV2 (variable-binding host on): `{Name}` pill, otherwise the expression chip.
 * Other hosts: the raw value as text. Clear / pill exit restores an array.
 */

function rawExpressionText(value) {
    if (typeof value === 'string')
        return value;
    try {
        return JSON.stringify(value);
    }
    catch (e) {
        return String(value);
    }
}

export default {
    mixins: [variableBindingMixin],
    methods: {
        exitVariableBindingMode() {
            this.closeVariablePicker();
            this._vbModeOverride = 'literal';
            this._vbLiteralScratch = undefined;
            this.sync(arrayExpressionRestoreValue(this.element?.schema));
        },
        clearEssentialsExpression() {
            this.closeVariablePicker();
            this._vbModeOverride = 'literal';
            this._vbLiteralScratch = undefined;
            this.sync(arrayExpressionRestoreValue(this.element?.schema));
        },
        /**
         * Pill, expression chip, or raw text. Null means render the normal array control.
         * @param {{ class?: string, labelSlot?: boolean }} [opts]
         * @returns {import('vue').VNode|null}
         */
        renderArrayExpressionStandIn(opts = {}) {
            const value = this.itemvalue;
            if (value == null || value === '' || Array.isArray(value))
                return null;

            if (typeof value === 'string') {
                const bound = this.tryRenderVariableBindingField(opts);
                if (bound)
                    return bound;
            }

            const label = this.variableBindingFieldLabel || this.Title;
            return (
                <div
                    class={['c-array-expression-raw', opts.class].filter(Boolean).join(' ')}
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                        marginBottom: '12px',
                    }}
                >
                    {label ? (
                        <div style={{ fontSize: '11px', color: '#607d8b', lineHeight: 1.2 }}>{label}</div>
                    ) : null}
                    <div
                        style={{
                            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
                            fontSize: '13px',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                        }}
                    >
                        {rawExpressionText(value)}
                    </div>
                </div>
            );
        },
    },
};
